import dynamic from 'next/dynamic';
// hooks
import useOneTrustCookie from '@/utils/hooks/useOneTrustCookie';

import {  isDDEnv } from '@/utils/helper';

const DynamicsForm = dynamic(() => import('./DynamicsForm'), {
  loading: () => <p>Loading...</p>,
  ssr: false,
});

export default function WithOneTrustCookie(props) {
  const { isConsented } = useOneTrustCookie('C0001');
  const isDD = isDDEnv();

  const extractContent = (content) => {
    if (!content) return {};

    const SCRIPT_SRC_REGEX = /<script[^>]*src\s*=\s*["']([^"']+)["'][^>]*>/g;
    const dynamicScripts = Array.from(
      content.matchAll(SCRIPT_SRC_REGEX),
      (m) => m?.[1]
    )?.filter(Boolean);

    const divContent = content.split('<script')?.[0];

    return {
      content: divContent,
      dynamicScripts: dynamicScripts,
    };
  };

  const { content, dynamicScripts } = extractContent(props.content);

  return (
    <div
      className="flex w-full min-h-[50vh] items-center justify-center"
      key={`wrapper-${props.id}-${isConsented}`}
    >
      {isConsented || isDD ? (
        <DynamicsForm {...{ ...props, content, dynamicScripts }} />
      ) : (
        <div className="bg-grey-900/10 text-body font-body">
          Please accept the cookie to continue
        </div>
      )}
    </div>
  );
}
